import { WpFilters, WpObjectPromise } from "src/app/service/global.service";
import { FiltreController } from "./filtre-controller";

export class WpFiltreController extends FiltreController {
  /**
   * @param promiseResult 
   * @returns all sdk versions in the promiseResult
   */
  public getAllSdkVersions(promiseResult: WpObjectPromise | undefined): string[] {
    let sdkVersions: any[] = []
    if (promiseResult) {
      let parseModels = JSON.parse(promiseResult.distinctSdkVersions)
      parseModels.forEach((sdkMap: Map<string, string>) => {
        sdkVersions.push(Object(sdkMap).wpSdkVersion)
      });
    }
    return sdkVersions
  }

  /**
   * @param promiseResult 
   * @returns all applications in the promiseResult
  */
  public getAllApplication(promiseResult: WpObjectPromise | undefined): string[] {
    if (!promiseResult) return [];
    return JSON.parse(promiseResult.distinctApplicationsNames)
      .filter((map: any) => map.appName)
      .map((map: any) => map.appName);
  }

  /**
   * @param promiseResult 
   * @returns all os names in the promiseResult
  */
  getAllOsNames(promiseResult: WpObjectPromise | undefined): string[] {
    if (!promiseResult) return [];
    const listOsAndV: { osName: string }[] = JSON.parse(promiseResult.distinctOsNamesAndVersions);
    const osNames: string[] = [...new Set(listOsAndV.map((os) => os.osName))];
    return osNames;
  }

  /**
   * @param promiseResult 
   * @param os 
   * @returns all versions for the given os
  */
  getAllVersionsForOs(promiseResult: WpObjectPromise | undefined, os: string): string[] {
    let l: any = []
    if (promiseResult) {
      let osVersions = JSON.parse(promiseResult.distinctOsNamesAndVersions)
      osVersions = osVersions.filter((map: Map<string, string[]>) => Object(map).osName.toLowerCase() == os.toLowerCase())
      osVersions.forEach((map: Map<string, string[]>) => l = Object(map).osVersion);
    }
    return l
  }

  /**
   * @param promiseResult 
   * @returns all browsers names in the promiseResult
  */
  getAllBrowserNames(promiseResult: WpObjectPromise | undefined): string[] {
    if (!promiseResult) return [];
    const listBrowsers: { browserName: string }[] = JSON.parse(promiseResult.distinctBrowserNamesAndVersions);
    const browserNames: string[] = [...new Set(listBrowsers.map((browser) => browser.browserName))];
    return browserNames;
  }

  /**
   * @param promiseResult 
   * @param browser 
   * @returns all versions for the given browser
  */
  getAllVersionsForBrowser(promiseResult: WpObjectPromise | undefined, browser: string): string[] {
    let l: any = []
    if (promiseResult) {
      let browserVersions = JSON.parse(promiseResult.distinctBrowserNamesAndVersions)
      browserVersions = browserVersions.filter((map: Map<string, string[]>) => Object(map).browserName.toLowerCase() == browser.toLowerCase())
      browserVersions.forEach((map: Map<string, string[]>) => l = Object(map).browserMajorVersion);
    }
    return l
  }

  /**
  * 
  * @param filterActive 
  * @param newfilter 
  * 
  * Change filterActive's attributes by newfilter's attributes
  */
  patchMainFilters(filterActive: WpFilters, newfilter: WpFilters | undefined) {
    filterActive.applicationsNames = newfilter?.applicationsNames
    filterActive.sdkVersions = newfilter?.sdkVersions
    filterActive.osNamesAndVersions = newfilter?.osNamesAndVersions
    filterActive.browserNamesAndVersions = newfilter?.browserNamesAndVersions
    filterActive.id = newfilter?.id
    filterActive.userId = newfilter?.userId
    filterActive.metadata = newfilter?.metadata
    return filterActive
  }

}